const format = (message, prefix, name, timestamp) => {
  let msg = ''
  if (prefix) {
    msg = `${prefix} `
  }
  if (timestamp) {
    msg += `${new Date().toLocaleDateString('de-de', { year:"numeric", month:"numeric", day:"numeric", hour: "2-digit", minute:"2-digit", second: "2-digit"}) } `
  }
  if (name) {
    msg += `[${name}] `
  }
  return `${msg}${message}`
}

const createLogger = (name, prefix, timestamp) => {
  return {
    warn(message, data) {
      if (process.env.NODE_ENV !== 'production') {
        if(data !== undefined){
            console.warn(format(message, prefix, name, timestamp), data)
          }else {
            console.warn(format(message, prefix, name, timestamp))
          }
      }
    },
    info(message, data) {
      if (process.env.NODE_ENV !== 'production') {
        if(data !== undefined){
            console.info(format(message, prefix, name, timestamp), data)
          }else {
            console.info(format(message, prefix, name, timestamp))
          }
      }
    },
    error(message, data) {
      if (process.env.NODE_ENV !== 'production') {
        if(data !== undefined){
            console.error(format(message, prefix, name, timestamp), data)
          }else {
            console.error(format(message, prefix, name, timestamp))
          }
      }
    },
    debug(message, data) {
        if (process.env.NODE_ENV !== 'production') {
          if(data !== undefined){
            console.debug(format(message, prefix, name, timestamp), data)
          }else {
            console.debug(format(message, prefix, name, timestamp))
          }
        }
      },
    print(message, data) {
      if (process.env.NODE_ENV !== 'production') {
        if(data !== undefined){
            console.log(format(message, prefix, name, timestamp), data)
          }else {
            console.log(format(message, prefix, name, timestamp))
          }
      }
    },
    log(message, data) {
        this.print(message, data)
    }
  }
}

const log = createLogger('', '', false)

export {createLogger, log}
